import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "components/Card";
import Input from "components/Form/Input";
import PageTitle from "components/Title/Page";
import axios from "axios";
import _ from "lodash";
import SpinnerMedium from "components/Spinner/Medium";
import { infoService } from "common/services/info";
import ComboBox from "components/Form/Combobox";
import Button from "components/Form/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Textarea from "components/Form/Textarea";
import EmptyForm from "components/Form/Empty";
import MultiBadgeCombo from "components/Form/MultiBadgeCombo";
import MultiImageUploader from "components/Form/Input/Image/MultiUploader";
import { staffClient } from "common/apis/staff";
import { useModal } from "components/Modal/Simple";
import FileUploadingSpinner from "common/components/FileUploadingSpinner";
import { FileService } from "common/services/file";
import Select from "components/Form/Select";

const ReviewEditPage = () => {
    const { reviewId } = useParams();
    const [reviewInfo, setReviewInfo] = useState(null);
    const [selectedClinicItem, setSelectedClinicItem] = useState(null);
    const [selectedClinicInfo, setSelectedClinicInfo] = useState(null);
    const [selectedEventItem, setSelectedEventItem] = useState(null);
    const [selectedTreatmentItems, setSelectedTreatmentItems] = useState(null);
    const [formData, setFormData] = useState(null);
    const { Modal: UploadingModal, openModal: openUploadingModal, closeModal: closeUploadingModal } = useModal();
    const navigate = useNavigate();

    useEffect(() => {
        console.log("[ReviewEditPage] useEffect");
        fetchReviewInfo();
    }, [])

    useEffect(() => {
        console.log("[ReviewEditPage] useEffect selectedClinicItem", selectedClinicItem);
        if (_.isNil(selectedClinicItem)) {
            return;
        }
        fetchSelectedClinicInfo();
    }, [selectedClinicItem])


    useEffect(() => {

    }, [selectedEventItem])

    useEffect(() => {
        console.log("[ReviewEditPage] useEffect selectedTreatmentItems", selectedTreatmentItems);
        if (_.isNil(selectedTreatmentItems)) {
            setFormData({
                ...formData,
                treatmentIds: []
            })
            return;
        }
        setFormData({
            ...formData,
            treatmentIds: selectedTreatmentItems.map((item) => item.id)
        })
    }, [selectedTreatmentItems])

    const fetchReviewInfo = async () => {
        try {
            // const ret = await axios.get(`https://rest.miview.shop/review/${reviewId}`);
            const ret = await staffClient.get(`/review/${reviewId}`);
            console.log("[ReviewEditPage] fetchReviewInfo ret", ret);
            const reviewData = ret.data;
            setReviewInfo(reviewData);
            setFormData({
                reviewId: reviewData.id,
                title: reviewData.title,
                content: reviewData.content,
                clinic: reviewData.clinic,
                event_id: reviewData.event?.id,
                treatmentIds: reviewData.treatments?.map((item) => item.id) ?? [],
                doctors: reviewData.doctors ?? [],
                beforePhotos: reviewData.beforePhotos ?? [],
                afterPhotos: reviewData.afterPhotos ?? [],
                rating: reviewData.rating
            })
            const clinics = infoService.getClinics();
            const clinicItem = clinics.find((item) => item.id === reviewData.clinic?.id);
            console.log("[ReviewEditPage] fetchReviewInfo clinicItem", clinicItem);
            setSelectedClinicItem(clinicItem);
            setSelectedEventItem({
                id: reviewData.event?.id,
                name: reviewData.event?.title,
                ...reviewData.event
            });
            setSelectedTreatmentItems(reviewData.treatments);
        } catch (e) {
            console.log("[ReviewEditPage] fetchReviewInfo error", e);
        }
    }

    const fetchSelectedClinicInfo = async () => {
        try {
            // const ret = await axios.get(`https://rest.miview.shop/clinic/${selectedClinicItem.id}`);
            const ret = await staffClient.get(`/clinic/${selectedClinicItem.id}`);
            console.log("[ReviewEditPage] fetchSelectedClinicInfo ret", ret);
            setSelectedClinicInfo(ret.data);
        } catch (e) {
            console.log("[ReviewEditPage] fetchSelectedClinicInfo error", e);
        }
    }

    const onSave = async () => {
        console.log("[ReviewEditPage] onSave", formData);
        openUploadingModal();
        try {
            // const ret = await axios.patch(`https://rest.miview.shop/review/${reviewId}`, formData);
            const uploadedBeforePhotos = await FileService.tryUploadFiles(formData.beforePhotos);
            const uploadedAfterPhotos = await FileService.tryUploadFiles(formData.afterPhotos);
            const body = {
                ..._.omit(formData, ["doctors", "clinic"]),
                clinic_id: selectedClinicItem?.id ?? null,
                doctorIds: formData.doctors.map((item) => item.id),
                beforePhotos: uploadedBeforePhotos,
                afterPhotos: uploadedAfterPhotos,
                treatmentIds: formData.treatmentIds
            }
            const ret = await staffClient.patch(`/review/${reviewId}`, body);
            console.log("[ReviewEditPage] onSave ret", ret);
            toast.success("리뷰가 수정되었습니다.");
            navigate("/main/review");
        } catch (e) {
            console.log("[ReviewEditPage] onSave error", e);
            toast.error("리뷰 수정 중 오류가 발생했습니다.");
        }
        closeUploadingModal();
    }

    if (_.isNil(reviewInfo) || _.isNil(formData)) {
        return <SpinnerMedium />
    }

    console.log("Selected Event Item", selectedEventItem);

    return (
        <Card>
            <div className="p-3 flex flex-col space-y-2">
                <PageTitle>리뷰 수정</PageTitle>
                <div>
                    <div className="font-semibold">
                        리뷰 ID
                    </div>
                    <Input
                        value={reviewId}
                        disabled={true}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        의원명
                    </div>
                    <ComboBox
                        items={infoService.getClinics()}
                        selectedItem={selectedClinicItem}
                        onChange={(item) => {
                            setSelectedEventItem(null);
                            setSelectedTreatmentItems(null);
                            setSelectedClinicItem(item);
                            setFormData({ ...formData, clinicId: item?.id, doctors: [] });
                        }}
                    />
                </div>
                {selectedClinicInfo && (
                    <div>
                        <div className="font-semibold">
                            이벤트명
                        </div>
                        <ComboBox
                            disabled={_.isNil(selectedClinicItem)}
                            items={selectedClinicInfo?.events.map((item) => ({ id: item.id, name: item.title, ...item }))}
                            selectedItem={selectedEventItem}
                            onChange={(item) => {
                                setSelectedTreatmentItems(null);
                                setSelectedEventItem(item);
                                setFormData({ ...formData, event_id: item?.id });
                            }}
                        />
                    </div>
                )}
                {selectedClinicInfo && (
                    <div>
                        <div className="font-semibold">
                            의사명
                        </div>
                        <EmptyForm>
                            <div className="p-2">
                                <MultiBadgeCombo
                                    items={selectedClinicInfo?.doctors}
                                    selectedItems={formData.doctors}
                                    onSelectedItemsChange={(items) => setFormData((prev) => ({ ...prev, doctors: items }))}
                                />
                            </div>
                        </EmptyForm>
                    </div>
                )}
                <div>
                    <div className="font-semibold">
                        시술명
                    </div>
                    <EmptyForm>
                        <div className="p-2">
                            <MultiBadgeCombo
                                items={infoService.getTreatments().filter((item) => {
                                    if (_.isNil(selectedEventItem)) {
                                        return true;
                                    }
                                    const isIncluded = selectedEventItem?.treatments?.find((treatment) => treatment.id === item.id);
                                    return isIncluded;
                                })}
                                selectedItems={selectedTreatmentItems}
                                onSelectedItemsChange={setSelectedTreatmentItems}
                            />
                        </div>
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        시술전 사진
                    </div>
                    <EmptyForm>
                        <MultiImageUploader
                            files={formData.beforePhotos}
                            onFileSelected={(files) => { setFormData((prev) => ({ ...prev, beforePhotos: [...prev.beforePhotos, ...files] })) }}
                            onFileChanged={(files) => setFormData({ ...formData, beforePhotos: files })}
                        />
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        시술후 사진
                    </div>
                    <EmptyForm>
                        <MultiImageUploader
                            files={formData.afterPhotos}
                            onFileSelected={(files) => { setFormData((prev) => ({ ...prev, afterPhotos: [...prev.afterPhotos, ...files] })) }}
                            onFileChanged={(files) => setFormData({ ...formData, afterPhotos: files })}
                        />
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        평점
                    </div>
                    <Select
                        items={[
                            { name: "5", data: 5 },
                            { name: "4", data: 4 },
                            { name: "3", data: 3 },
                            { name: "2", data: 2 },
                            { name: "1", data: 1 },
                        ]}
                        selectedItem={{ name: String(formData.rating), data: formData.rating }}
                        onChange={(item) => setFormData({ ...formData, rating: item.data })}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        제목
                    </div>
                    <Input
                        value={formData.title}
                        onChange={(value) => setFormData({ ...formData, title: value })}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        내용
                    </div>
                    <Textarea
                        value={formData.content}
                        onChange={(value) => setFormData({ ...formData, content: value })}
                        resizable={true}
                        minRows={5}
                    />
                </div>
                <div className="border-t border-gray-300"></div>
                <div>
                    <div className="flex justify-between space-x-2">
                        <div>
                            <Button
                                onButtonClicked={() => { navigate("/main/doctor") }}
                            >
                                목록
                            </Button>
                        </div>
                        <div className="flex space-x-2">
                            <div>
                                <Button
                                    onButtonClicked={() => {
                                        const tempReviewInfo = {
                                            ..._.omit(formData, ["clinicId", "eventId", "treatmentIds", "doctorIds"]),
                                            clinic: selectedClinicItem,
                                            event: selectedEventItem,
                                            treatments: formData.treatmentIds.map((id) => infoService.getTreatmentById(id)),
                                            doctors: formData.doctorIds.map((id) => selectedClinicInfo.doctors.find((item) => item.id === id)),
                                        }
                                        window.localStorage.setItem("tempReviewInfo", JSON.stringify(tempReviewInfo));
                                        window.open(`/preview/review/pv`, "_blank");
                                    }}
                                >
                                    미리보기
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onButtonClicked={onSave}
                                >
                                    저장
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <UploadingModal>
                <FileUploadingSpinner />
            </UploadingModal>
        </Card>
    )
}

export default ReviewEditPage;
